import * as R from 'ramda'
import {
  WAPP_COMMUNICATE_CORE_CREATE_CHAT,
  WAPP_COMMUNICATE_CORE_GET_CHAT_BY_ID,
  WAPP_COMMUNICATE_CORE_GET_CURRENT_CHAT_INFO,
  WAPP_COMMUNICATE_CORE_GET_PUBLIC_CHAT_BY_USERNAME,
  WAPP_COMMUNICATE_CORE_JOIN_CHAT,
  WAPP_COMMUNICATE_CORE_OPEN_CHAT_PROFILE,
  WAPP_COMMUNICATE_CORE_SET_CHAT_EDU_PROFILE,
  wappCommunicateCoreGetChatById,
  wappCommunicateCoreGetCurrentChatInfo,
  wappCommunicateCoreGetPublicChatByUsername,
  wappCommunicateCoreSetChatEduProfile,
} from '@weblite/wapp-communication-action/core'
import { wappSub } from '$func/subscription'
import { sendOldActionToWapp } from '$logic/wapp-communication/wapp-communication.publish'
import { getRoom, isClientsRoom } from '$logic/room'
import { getHall, getHallByIdentifier, isPublicHall } from '$logic/hall'
import {
  joinHall,
  getSubscription,
  decodeMemberPermissions,
} from '$logic/subscription'
import { getOpenedRoomId, openRoom } from '$logic/opened-room'
import { RoomTypes } from '@weblite/ts-action/room'

const roomTypeToOldChatType: Record<RoomTypes, string> = {
  GROUP: 'group',
  CHANNEL: 'channel',
  PRIVATE_SPACE: 'pv',
  WAPP_ROOM: 'pv',
  PV: 'pv',
}

async function getHallInfoInOldFormat(roomId: string) {
  const hall = await getHall(roomId)
  if (!hall?.roomId) return {}

  const isMember = isClientsRoom(roomId)

  // TODO: Check old chat types
  const roomType = (await getRoom(roomId))?.type

  const subscription = await getSubscription(roomId)
  const { isAdmin } = decodeMemberPermissions(hall, subscription)

  return {
    id: roomId,
    profileImage: hall.image,
    username: hall.identifier,
    type: roomTypeToOldChatType[roomType!],
    isMember,
    isAdmin,
    ...R.pick(['name', 'description', 'membersCount'], hall),
  }
}

wappSub.subscribe(
  WAPP_COMMUNICATE_CORE_GET_CHAT_BY_ID,
  async ({ payload: { id }, meta }) => {
    const chatInfo = await getHallInfoInOldFormat(id)
    sendOldActionToWapp(wappCommunicateCoreGetChatById({ chatInfo }), meta)
  },
  true,
)

wappSub.subscribe(
  WAPP_COMMUNICATE_CORE_GET_PUBLIC_CHAT_BY_USERNAME,
  async ({ payload: { username }, meta }) => {
    const hall = await getHallByIdentifier(username)

    if (!hall?.public) {
      sendOldActionToWapp(
        wappCommunicateCoreGetPublicChatByUsername({
          chatInfo: {},
        }),
        meta,
      )

      return
    }

    const chatInfo = await getHallInfoInOldFormat(hall.roomId)
    sendOldActionToWapp(
      wappCommunicateCoreGetPublicChatByUsername({ chatInfo }),
      meta,
    )
  },
  true,
)

wappSub.subscribe(
  WAPP_COMMUNICATE_CORE_GET_CURRENT_CHAT_INFO,
  async ({ meta }) => {
    const openedRoomId = await getOpenedRoomId()
    const currentChatInfo = await getHallInfoInOldFormat(openedRoomId)

    sendOldActionToWapp(
      wappCommunicateCoreGetCurrentChatInfo({
        currentChatInfo,
      }),
      meta,
    )
  },
  true,
)

wappSub.subscribe(
  WAPP_COMMUNICATE_CORE_JOIN_CHAT,
  async ({ id: roomId, category }) => {
    // TODO: Check usage of category
    const isMemberOfChat = isClientsRoom(roomId)

    if (!isMemberOfChat) {
      await joinHall(roomId)
    } else if (roomId !== getOpenedRoomId()) await openRoom(roomId)
  },
)

wappSub.subscribe(WAPP_COMMUNICATE_CORE_CREATE_CHAT, ({ type }) => {
  if (!['group', 'channel'].includes(type)) return

  // TODO: Implement if needed
})

wappSub.subscribe(WAPP_COMMUNICATE_CORE_OPEN_CHAT_PROFILE, ({ id }) => {
  openRoom(id)
})

wappSub.subscribe(
  WAPP_COMMUNICATE_CORE_SET_CHAT_EDU_PROFILE,
  async ({ payload: { id }, meta }) => {
    // TODO: Implement
  },
  true,
)
